module.exports = __webpack_public_path__ + "img/news-2.498d8f26.png";